import React, { useState } from 'react';
import SubscriptionList from './components/subscriptionList';
import SubscriptionModal from './components/subscriptionModal';
import useSubscriptionState from './hooks/useSubscriptionState';
import { useNavigate } from 'react-router-dom';

const SubscriptionPage = () => {
  const navigate = useNavigate();
  const { subscriptions, loading, addOrUpdate, markInactive } = useSubscriptionState();

  const [modalOpen, setModalOpen] = useState(false);
  const [editingSubscription, setEditingSubscription] = useState(null);

  const handleAdd = () => {
    navigate('/subscriptions/add');
  };

  const handleEdit = (record) => {
    navigate(`/subscriptions/edit/${record.customer_id}`);
  };

  const handleSave = async (subscription) => {
    const response = await addOrUpdate(subscription);
    if (response?.success) {
      setModalOpen(false);
    }
  };

  const handleDelete = async (customer_id, id, date) => {
    await markInactive(customer_id, id, date);
  };

  return (
    <>
      <SubscriptionList
        subscriptions={subscriptions}
        loading={loading}
        onEdit={handleEdit}
        markInactive={handleDelete}
        onAdd={handleAdd}
      />
      <SubscriptionModal
        visible={modalOpen}
        onCancel={() => setModalOpen(false)}
        onSave={handleSave}
        initialData={editingSubscription}
      />
    </>
  );
};

export default SubscriptionPage;
